import { useFormContext } from "react-hook-form";
import { AddOnTextInput, ErrorMessage, Icon, Tooltip, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddTransferTypeFormData } from "../form";

export const TransferTypeCostField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddTransferTypeFormData>();

  return (
    <div className={clsx("flex w-full gap-5", className)} {...props}>
      <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
        <Typography variant="paragraph" className="flex items-center gap-2">
          Cost Adjustment
          <Tooltip content="The base trip cost will increase by the percentage you’ve entered" placement="right">
            <span>
              <Icon name="InfoCircle" variant="Bold" className="rotate-180 text-neutral-dark-gray" size="md" />
            </span>
          </Tooltip>
        </Typography>
        <AddOnTextInput
          className="[&>div]:w-full"
          type="number"
          placeholder="0"
          endAddOn="%"
          step="0.01"
          hasError={!!errors.costAdjustment}
          {...register("costAdjustment", {
            valueAsNumber: true,
          })}
        />
        <ErrorMessage errors={errors} name="costAdjustment" />
      </div>
    </div>
  );
};
